"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;
var _default = {
  isType: function isType(identifier) {
    var mXn = identifier.substr(5);
    if (mXn || (mXn = "128x18"), !mXn || -1 === mXn.indexOf("x")) return !1;
    var m = mXn.substr(0, mXn.indexOf("x")),
        n = mXn.substr(mXn.indexOf("x") + 1, mXn.length);
    return "" !== n && "" !== m && identifier.startsWith("fixed") && 0 == m % 8 && 256 >= m && 8 <= m && 80 >= n && 0 <= n;
  }
};
exports.default = _default;